import { HttpClient, HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import * as Sentry from "@sentry/angular-ivy";
import { SessionService } from 'src/app/services/session/session.service';

@Component({
  selector: 'app-chatbase',
  templateUrl: './chatbase.component.html',
  styleUrls: ['./chatbase.component.scss']
})
export class ChatbaseComponent implements OnInit {

  iframeErrorLoading: boolean = false;
  iframeSuccessLoading: boolean = false;

  constructor(private http: HttpClient, private sessionService: SessionService) { }

  ngOnInit(): void {
    setTimeout(() => {
      if (!this.iframeErrorLoading && !this.iframeSuccessLoading) {
        console.error('Timeout: assistente demorou para carregar');
        this.iframeErrorLoading = true;
        this.logarSentry("Timeout de carregamento do assistente");
      }
    }, 15000);

    this.http.get("https://status.chatbase.co/v2/components.json", {
      responseType: 'text',
      observe: 'response'
    }).subscribe(
      (response: HttpResponse<any>) => {
      },
      error => {
        this.logarSentry({
          message: "Erro ao acessar status.chatbase.co",
          error
        });
      }
    );
  }

  onErrorIframe(e: any) {
    console.error('Erro real no iframe de chat', e);
    this.iframeErrorLoading = true;
    this.iframeSuccessLoading = false;
    this.logarSentry(e);
  }

  logarSentry(error: any) {
    Sentry.configureScope(scope => {
      scope.setTag("companyId", this.sessionService.getDetails().idCompany);
      scope.setExtra("extra-info", JSON.stringify(error));
    });

    Sentry.captureMessage('Erro ao abrir Assistente', 'info');
  }
}
